module.exports = __webpack_public_path__ + "img/logo-icrea-white-login.58bae7d6.svg";